import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AlertService } from '../auth/alertservice';

@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AlertComponent implements OnInit, OnDestroy {
    private subscription: Subscription = Subscription.EMPTY;
    message: any;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.subscription = this.alertService.getMessage().subscribe(message => {
            this.message = message;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
